import PropTypes from 'prop-types';

const ProtectedItem = (props) => {
  if (props.auth.checkPermission(props.allowedPermissions)) {
    return props.children;
  }
  return null;
};

export default ProtectedItem;

ProtectedItem.defaultProps = {
  allowedPermissions: [],
};

ProtectedItem.propTypes = {
  allowedPermissions: PropTypes.arrayOf(PropTypes.string),
};



// WEBPACK FOOTER //
// ./src/components/ComponentesAutenticacao/ProtectedItemWithAuth.js